import { InstantSearchSSRProvider } from "react-instantsearch";

import {
  ARTICLE_INDEX,
  ARTICLE_SERIES_ARTICLES_INDEX,
} from "@/components/pieces/algolia/indexes";
import ArticleSeriesSearch from "@/components/pieces/learn/search/ArticleSeriesSearch";

interface SeoArticleSeriesContainerProps {
  articleSeries?: any;
  resultsState?: any;
  [key: string]: any;
}

export default function SeoArticleSeriesContainer(
  props: SeoArticleSeriesContainerProps,
) {
  const indexName =
    props?.articleSeries?.urlSlug === "other-articles"
      ? ARTICLE_INDEX
      : ARTICLE_SERIES_ARTICLES_INDEX;

  return (
    <InstantSearchSSRProvider {...props.resultsState}>
      <ArticleSeriesSearch indexName={indexName} {...props} />
    </InstantSearchSSRProvider>
  );
}
